import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

const CACHE_TIME = 60_000;
const STALE_TIME = 60_000;

function useFetchTopOffers({
  reservationId,
  enabled = true,
}: {
  reservationId?: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.topOffers, reservationId],
    queryFn: () => API.upselling.getTopOffers(reservationId!),
    enabled: Boolean(reservationId) && enabled,
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
  });
}

export {useFetchTopOffers};
